export const fontAdellesans = "adelle sans";
export const fontMonoLisa = "Mono Lisa";
export const fontInter = "Inter";
export const fontDiatype = "Diatype";
export const familyBody = "Diatype, Helvetica Neue, Helvetica, Arial, sans-serif";
export const familyBrand = "Diatype, Helvetica Neue, Helvetica, Arial, sans-serif";
export const familyDisplay = "Diatype, Helvetica Neue, Helvetica, Arial, sans-serif";
export const familyCode = "Mono Lisa, SFMono-Regular, Menlo, Monaco, Consolas, \"Liberation Mono\", monospace";
export const styleNormal = "normal";
export const styleItalic = "italic";
export const size50 = "10px";
export const size100 = "10px";
export const size200 = "12px";
export const size300 = "15px";
export const size400 = "20px";
export const size500 = "25px";
export const size600 = "35px";
export const size700 = "35px";
export const size800 = "45px";
export const size900 = "55px";
export const size1000 = "75px";
export const sizeBase = "15px";
export const height50 = "12px";
export const height100 = "12px";
export const height200 = "15px";
export const height300 = "20px";
export const height400 = "23px";
export const height500 = "28.75px";
export const height600 = "38.5px";
export const height700 = "38.5px";
export const height800 = "45px";
export const height900 = "55px";
export const height1000 = "75px";
export const weight100 = 100;
export const weight300 = 300;
export const weight400 = 400;
export const weight500 = 500;
export const weight600 = 600;
export const weight700 = 700;
export const weightBody = 400;
export const weightBodyBold = 700;
export const weightBodyMedium = 500;
export const weightBodySemiBold = 500;
export const weightDisplay = 400;
export const weightHeading = 700;
export const weightHeadingLight = 500;
export const spacing200 = "-3px";
export const spacing300 = "-2px";
export const spacing400 = "-1px";
export const spacing500 = "0px";
export const spacingBase = "0px";
export const heading100Family = "Diatype, Helvetica Neue, Helvetica, Arial, sans-serif";
export const heading100Size = "12px";
export const heading100Height = "15px";
export const heading100Weight = 700;
export const heading100Color = "#333333";
export const heading100Margin = "2px";
export const heading100LetterSpacing = "0px";
export const heading200Family = "Diatype, Helvetica Neue, Helvetica, Arial, sans-serif";
export const heading200Size = "15px";
export const heading200Height = "20px";
export const heading200Weight = 700;
export const heading200Color = "#333333";
export const heading200Margin = "2px";
export const heading200LetterSpacing = "0px";
export const heading300Family = "Diatype, Helvetica Neue, Helvetica, Arial, sans-serif";
export const heading300Size = "20px";
export const heading300Height = "23px";
export const heading300Weight = 700;
export const heading300Color = "#333333";
export const heading300Margin = "5px";
export const heading300LetterSpacing = "-1px";
export const heading400Family = "Diatype, Helvetica Neue, Helvetica, Arial, sans-serif";
export const heading400Size = "20px";
export const heading400Height = "23px";
export const heading400Weight = 700;
export const heading400Color = "#333333";
export const heading400Margin = "5px";
export const heading400LetterSpacing = "-1px";
export const heading500Family = "Diatype, Helvetica Neue, Helvetica, Arial, sans-serif";
export const heading500Size = "25px";
export const heading500Height = "28.75px";
export const heading500Weight = 700;
export const heading500Color = "#333333";
export const heading500Margin = "10px";
export const heading500LetterSpacing = "-1px";
export const heading600Family = "Diatype, Helvetica Neue, Helvetica, Arial, sans-serif";
export const heading600Size = "35px";
export const heading600Height = "38.5px";
export const heading600Weight = 700;
export const heading600Color = "#333333";
export const heading600Margin = "15px";
export const heading600LetterSpacing = "-1px";
export const heading650Family = "Diatype, Helvetica Neue, Helvetica, Arial, sans-serif";
export const heading650Size = "35px";
export const heading650Height = "38.5px";
export const heading650Weight = 700;
export const heading650Color = "#333333";
export const heading650Margin = "15px";
export const heading650LetterSpacing = "-1px";
export const heading700Family = "Diatype, Helvetica Neue, Helvetica, Arial, sans-serif";
export const heading700Size = "45px";
export const heading700Height = "45px";
export const heading700Weight = 700;
export const heading700Color = "#333333";
export const heading700Margin = "20px";
export const heading700LetterSpacing = "-2px";
export const heading800Family = "Diatype, Helvetica Neue, Helvetica, Arial, sans-serif";
export const heading800Size = "55px";
export const heading800Height = "55px";
export const heading800Weight = 700;
export const heading800Color = "#333333";
export const heading800Margin = "25px";
export const heading800LetterSpacing = "-2px";
export const heading900Family = "Diatype, Helvetica Neue, Helvetica, Arial, sans-serif";
export const heading900Size = "75px";
export const heading900Height = "75px";
export const heading900Weight = 700;
export const heading900Color = "#333333";
export const heading900Margin = "30px";
export const heading900LetterSpacing = "-3px";
export const body200Family = "Diatype, Helvetica Neue, Helvetica, Arial, sans-serif";
export const body200Size = "10px";
export const body200Height = "12px";
export const body200Weight = 400;
export const body200Style = "normal";
export const body200Color = "#333333";
export const body300Family = "Diatype, Helvetica Neue, Helvetica, Arial, sans-serif";
export const body300Size = "12px";
export const body300Height = "15px";
export const body300Weight = 400;
export const body300Style = "normal";
export const body300Color = "#333333";
export const body400Family = "Diatype, Helvetica Neue, Helvetica, Arial, sans-serif";
export const body400Size = "15px";
export const body400Height = "20px";
export const body400Weight = 400;
export const body400Style = "normal";
export const body400Color = "#333333";
export const body500Family = "Diatype, Helvetica Neue, Helvetica, Arial, sans-serif";
export const body500Size = "15px";
export const body500Height = "20px";
export const body500Weight = 400;
export const body500Style = "normal";
export const body500Color = "#333333";
export const body600Family = "Diatype, Helvetica Neue, Helvetica, Arial, sans-serif";
export const body600Size = "15px";
export const body600Height = "20px";
export const body600Weight = 400;
export const body600Style = "normal";
export const body600Color = "#333333";
export const bodyBoldWeight = 700;
export const bodyItalicStyle = "italic";
export const headingAliasesXs = 100;
export const headingAliasesSmall = 200;
export const headingAliasesMedium = 400;
export const headingAliasesLarge = 600;
export const headingAliasesXl = 700;
export const headingAliasesXxl = 900;
export const bodyAliasesFootnote = 200;
export const bodyAliasesSmall = 300;
export const bodyAliasesMedium = 400;